import PropTypes from 'prop-types';
import React from 'react';
import PhaseType from 'types/phase';

const flag_note = ({ event: { kind, data: { name, suboption } } }) =>
  <div className={kind}>
    {name}{suboption && ` - ${suboption}`}
  </div>;

flag_note.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      name: PropTypes.string.isRequired,
      suboption: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};

export { flag_note as flag_added, flag_note as flag_removed };



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/flag_added.jsx